import React from "react";
import "./FeedEvents.css";

const WEBINAR_URL =
  "https://supportly.au/ndis-cyber-security?utm_source=website&utm_medium=news-card&utm_campaign=prs-ep2";

/**
 * Temporary featured announcement in the Events tab.
 * Live events from Super Admin replace this card in the same slot later.
 */
const HardcodedUpcomingEventCard = () => (
  <article className="feed-event-card">
    <img
      src="https://assets.cdn.filesafe.space/ilhJwiLRn6CclnfD0xSM/media/6ae18853736386d0dc1edef5.png"
      alt="Provider Readiness Series, live: Your Participant Files Are a Target, Cyber Security for NDIS Providers. Host Faraz Khan and guest Naseer Sahi."
      className="feed-event-card__media"
    />
    <div className="feed-event-card__body">
      <div className="feed-event-card__tags">
        <span className="feed-event-card__badge">Webinar</span>
        <span className="feed-event-card__series">
          Provider Readiness Series, Episode 2
        </span>
      </div>

      <h2 className="feed-event-card__title">
        Your Participant Files Are a Target:{" "}
        <span className="feed-event-card__title-accent">
          Cyber Security for NDIS Providers
        </span>
      </h2>

      <p className="feed-event-card__meta">
        <span>Thursday 5 November 2026</span>
        <span>3:00 PM AEDT</span>
        <span>Live on StreamYard</span>
        <span>Free, 45 minutes</span>
      </p>

      <div className="feed-event-card__text">
        <p>
          Health service providers made more data breach notifications than any
          other sector in Australia in the OAIC&apos;s July to December 2024
          report. For NDIS providers, every participant file holds identity,
          health, funding and family details in one place.
        </p>
        <p>
          In Episode 2, Faraz Khan, Founder of Supportly (Vertex 360), talks
          with Naseer Sahi, Cyber Security Expert, about three risks:
        </p>
        <ol>
          <li>
            <strong>Breach exposure</strong>
          </li>
          <li>
            <strong>Privacy obligations</strong>
          </li>
          <li>
            <strong>Breach response</strong>
          </li>
        </ol>
        <p>
          Send your question when you register. Faraz will put a selection to
          Naseer on air.
        </p>
      </div>

      <a
        href={WEBINAR_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="feed-event-card__cta"
      >
        Register for the webinar
      </a>
    </div>
  </article>
);

export default HardcodedUpcomingEventCard;
